'use client';

import { c as _c } from "react/compiler-runtime";
import Footer from '@pc/components/organisms/footer/Footer';
import TopNavContainer from '@pc/components/top-nav/TopNavContainer';
import { Suspense } from 'react';
import ChannelBody from './_components/ChannelBody';
import ChannelHeader from './_components/ChannelHeader';
async function ChannelLayoutContent(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TopNavContainer narrow={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChannelHeader />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <ChannelBody>{children}</ChannelBody>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Footer className="min-w-[1360px]" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <>{t1}<div className="mt-16 h-full w-full pt-12" data-testid="channel-home-page"><div className="mx-auto">{t2}{t3}{t4}</div></div></>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export default async function RootLayout(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props.children) {
    t0 = <Suspense fallback={null}><ChannelLayoutContent>{props.children}</ChannelLayoutContent></Suspense>;
    $[0] = props.children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}